export const environment = {
    apiUrl: 'https://inventory.onlinepos.me/core',
    oriURL: 'https://inventory.onlinepos.me',
    content: 'https://inventory.onlinepos.me/content/'
};
